"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getGroups = function (page, pageSize) {
    return (0, service_1.getService)()
        .get("/managed_campus/device_groups/?page=".concat(page, "&page_size=").concat(pageSize))
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .catch(function (_a) {
        var response = _a.response;
        return Promise.reject(response.data);
    });
};
exports.default = getGroups;
